import { createIcon } from '../createIcon';

export const CaretSquareLeftIconConfig = {
  name: 'CaretSquareLeftIcon',
  height: 512,
  width: 448,
  svgPath: 'M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const CaretSquareLeftIcon = createIcon(CaretSquareLeftIconConfig);

export default CaretSquareLeftIcon;